import { AbstractControl, FormControl, ValidatorFn, Validators } from "@angular/forms";
import { createTrue } from "typescript";


export class CustomValidators{

    static number(prms :any): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
/*           if(isPresent(Validators.required(control))) {
            return null;
          } */
          
          let val: number = control.value;
    
          if(isNaN(val) || /\D/.test(val.toString())) {
            
            return {"number": true};
          } else if(!isNaN(prms.min) && !isNaN(prms.max)) {
            
            return val < prms.min || val > prms.max ? {"number": true} : null;
          } else if(!isNaN(prms.min)) {
            
            return val < prms.min ? {"number": true} : null;
          } else if(!isNaN(prms.max)) {
            
            return val > prms.max ? {"number": true} : null;
          } else {
            
            return null;
          }
        };
      }

      public static smallerThan(otherControlName: string) {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            if (!control.parent) {
                return null; // Control is not yet associated with a parent.
            }
            const thisValue = control.value;
            const otherControl=control.parent.get(otherControlName);
            const otherValue = otherControl.value;
            if (otherValue==null || thisValue==null){
                return null;
            }
            else if ( thisValue < otherValue) {
              //otherControl.updateValueAndValidity({onlySelf:true,emitEvent:false});
                return null;
            }
    
            return {
                'smallerthan': true
            }
        };
    }
    
      public static greaterThan(otherControlName: string) {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            if (!control.parent) {
                return null; // Control is not yet associated with a parent.
            }
            const thisValue = control.value;
            const otherControl=control.parent.get(otherControlName);
            const otherValue = otherControl.value;
            if (otherValue==null || thisValue==null){
                return null;
            }
            else if ( thisValue > otherValue) {
                //otherControl.updateValueAndValidity({onlySelf:true,emitEvent:false});
                return null;
            }
    
            return {
                'greaterthan': true
            }
        };
    }

}